<template>
  <pdl-form-group
    v-model="regionIso"
    :multi-items="transformedRegions"
    name="regionIso"
    :label="$t('address.state')"
    type="select"
    :error="fieldError"
    required
    @update:modelValue="clearErrors"
  />
</template>

<script>
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {mapState, mapMutations} from 'vuex';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';
export default {
  components: {PdlFormGroup},
  mixins: [TrekValidationMixin],
  inject: ['validationErrors', 'clearValidationErrors'],
  props: {
    regions: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  validations() {
    return {
      regionIso: {
        required: this.trekValidators.requiredWithCustomMessage('address.regionIso.invalid'),
      },
    };
  },
  computed: {
    ...mapState('checkout', ['billingAddress']),
    regionIso: {
      get() {
        return this.billingAddress.regionIso ? this.billingAddress.regionIso : this.modelValue;
      },
      set(regionIso) {
        this.setRegionIso(regionIso);
      },
    },
    transformedRegions() {
      const transformedRegions = this.regions.map((region) => {
        return {
          displayName: region.name,
          value: region.isocode,
        };
      });
      transformedRegions.unshift({displayName: this.$t('form.select.empty'), disabled: true, value: ''});
      return transformedRegions;
    },
    fieldName() {
      return 'regionIso';
    },
    fieldError() {
      const theError =
        this.validationErrors.find((item) => item.field === this.fieldName)?.msg ??
        this.getErrorMessage(this.fieldName);

      return theError;
    },
  },
  methods: {
    ...mapMutations('checkout', ['setRegionIso']),
    clearErrors() {
      if (!this.validationErrors.length) return;
      this.clearValidationErrors();
    },
  },
};
</script>
